import { apiSlice } from "../api/apiSlice";

export const registrosMailApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getRegistrosMail: builder.query({
      query: () => 'registros-mail',
      providesTags: (result, error, arg) => [
        { type: 'RegistrosMail', id: 'LIST' },
      ]
    }),
    getBatchEnviosMail: builder.query({
      query: () => 'batch-envios-mail',
      providesTags: (result, error, arg) => [
        { type: 'BatchEnviosMails', id: 'LIST' },
      ]
    }),
    getCupones: builder.query({
      query: () => 'cupones',
      providesTags: (result, error, arg) => [
        { type: 'Cupones', id: 'LIST' },
      ]
    }),
    crearCuponesMensuales: builder.mutation({
      query: (cupones) => (
        {
          url: 'cupones-mensuales',
          method: 'post',
          body: cupones
        }),
      invalidatesTags: ["Contratos", "RegistrosMail", "Cupones", "BatchEnviosMails"],
    }),
    // Nuevo query para obtener registros por ID de lote de envío
    getRegistrosMailByBatchId: builder.query({
      query: (batchId) => `registros-mail/batch/${batchId}`,
      providesTags: (result, error, batchId) => [
        { type: 'RegistrosMail', id: 'LIST' },
        { type: 'RegistrosMail', id: batchId }, // Puedes ajustar este tag según tus necesidades
      ],
    }),
  })
})

export const { useGetCuponesQuery, useGetRegistrosMailQuery, useGetBatchEnviosMailQuery, useCrearCuponesMensualesMutation,useGetRegistrosMailByBatchIdQuery } = registrosMailApi;